import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import { PitchTitleIcon } from 'sections/Benefits/svg';
import styles from 'styles/pages/Benefits/BrandReliability/BrandReliability.module.scss';

const cn = classNames.bind(styles);

const SectionPitch = (): ReactElement => {
  return (
    <section className={cn('pitch')}>
      <div className={cn('container')}>
        <div className={cn('pitch__title-box')}>
          <h2 className={cn('pitch__title')}>
            {PitchTitleIcon}
            Your Partner in Connecting You With Reliable Brands
          </h2>
          <p className={cn('pitch__title-description')}>
            Unwavering trust and credibility for your freight-forwarding business.
          </p>
        </div>
        <div className={cn('pitch__paragraphs')}>
          <p className={cn('pitch__paragraph')}>
            In a competitive industry where reputation is key, DFA empowers you to enhance your brand’s reliability 
            and credibility. By joining our global network of vetted, trustworthy professionals, you demonstrate 
            your commitment to excellence and gain access to the exclusive tools and resources that reinforce your brand’s 
            reliability. Ensure your reputation stands out as a cornerstone of trust and excellence in the freight 
            forwarding world with DFA.
          </p>
        </div>
        <div className={cn('pitch__buttons')}>
          <Link className={cn('pitch__button-join')} href="/membership">
            Join DFA Alliance Now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SectionPitch;